import type { ProjectLinkSectionFragment } from '@dreamstack/investors-graphql'
import map from 'lodash/map'
import type { FunctionComponent } from 'react'
import 'twin.macro'
import { BodyText, HeadingH2 } from '../index'
import { CallToActionTile } from './CallToActionTile'

export const VirtualRoundtrip: FunctionComponent<React.PropsWithChildren<{
  projectLinkSection: ProjectLinkSectionFragment
}>> = ({ projectLinkSection }) => {
  const links = projectLinkSection?.projectLinksCollection?.items
  return (
    <>
      <HeadingH2 tw="col-span-12 mt-px-48 md:mt-px-96 lg:(col-start-2 col-span-10)">
        {projectLinkSection.title}
      </HeadingH2>
      <BodyText tw="col-span-12 lg:(col-start-2 col-span-8) mt-px-32 mb-px-40">
        {projectLinkSection.description}
      </BodyText>
      <div tw="col-span-12  mt-px-16 md:(mt-px-80)">
        <div tw="grid grid-cols-1 gap-px-16 md:(grid-cols-3 gap-px-48) lg:grid-cols-4">
          {map(links, (link, i) => (
            <CallToActionTile
              backgroundImageUrl={link!.backgroundImage?.url ?? undefined}
              targetBlank
              caption={link?.title ?? ''}
              href={link?.link ?? ''}
              key={`${i}${link?.link ?? ''}`}
            />
          ))}
        </div>
      </div>
    </>
  )
}
